/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useToast } from '../../../../components/Toats';
import { StepperComponent } from '../../../../../../_metronic/assets/ts/components';
import { useAuth } from '../../../../../modules/auth';
import useSize from '../../../../../hooks/useSize';
import { getUnitBranchAllSimple } from '../../../../../services/unitBranchService';
import { createPlantComposite } from '../../../../../services/plantsService';
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { SelectGlobal } from '../../../../components/SelectGlobal';
import { LoadingSpan } from '../../../../components/Loadings/loadingSpan';
import { ListPlantsForComposite } from './components/ListPlantsForComposite';

type Props = {
    show: boolean;
    handleClose: () => void
}

const validationSchema = Yup.object().shape({
  value_implementation: Yup.number(),
  annual_generation_forecast: Yup.number(),
});


const modalsRoot = document.getElementById('root-modals') || document.body

const ModalCreatePlantCompositeTable = ({show, handleClose}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)
  const {currentUser} = useAuth();
  const [unitBranchs, setUnitBranch] = useState<any[]>([]);

  const [initialValues] = useState<any>({
    plantName: null,
    plano: null,
    idUnitBranch: null,
    idsPlants: [],
  })
  const {width} = useSize()
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    formik.resetForm();
    handleClose()
  }

  const getUnitBranch = async () => {
    try {
      const unitBranch = await getUnitBranchAllSimple()
      setUnitBranch(unitBranch)

    } catch (error) {
      console.log(error)
      //toggleToast("Erro ao buscar as unidades filiais. ", "error")
    }
  }

  const createPlantCompositeSubmit = async () => {
    try {
      setLoading(true)
      const body = {
        plantName: formik.values.plantName ? formik.values.plantName : null,
        plano: formik.values.plano ? formik.values.plano : null,
        idUnitBranch: formik.values.idUnitBranch ? formik.values.idUnitBranch : null,
        idsChildPlants: formik.values.idsPlants && formik.values.idsPlants.length > 0 ? formik.values.idsPlants : [],
        type_plant: "COMPOSTA",
        status: 9,
      };

      await createPlantComposite(body);
      
      toggleToast("Sucesso ao criar a usina composta.", "success")

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao criar a usina composta.", "error")
    }finally{
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    createPlantCompositeSubmit()
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: submit,
  });


  useEffect(() => {
    if(currentUser && currentUser.role && currentUser.role.slug !== "ADMIN"){
      getUnitBranch()
    }
  }, [])

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Criação da Usina COMPOSTA</span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
         
          <div className='flex-row-fluid py-lg-0'>
            <div style={{display: 'flex', gap: '4rem', alignItems: 'center', width: '100%', justifyContent: 'space-between'}}>
              <div style={{flex: '1'}}>
                <SelectGlobal 
                    itens={unitBranchs}
                    buttonAll={true}
                    textSearch={"Buscar unidade FILIAL"}
                    textButtonInit={"Selecione a FILIAL"}
                    labelKey='companyName'
                    valueKey='id'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/ecommerce/ecm009.svg'
                    sizeIconSvg='2'
                    value={formik.values.idUnitBranch}
                    className={"w-100"}
                    onChange={(value: string) => {
                        formik.setValues({...formik.values, idUnitBranch: value})
                    }}
                />

                  <div style={{display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '1.5rem'}}>
                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1', minWidth: '15rem'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Nome da usina</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Nome da usina'
                          ></i>
                      </label>
                      <input
                          type='text'
                          className='form-control form-control-lg'
                          name='plantName'
                          placeholder=''
                          value={formik.values.plantName}
                          onChange={formik.handleChange("plantName")}
                      />
                    </div>
                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1', minWidth: '15rem'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Plano da usina</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Valor da implantação da usina'
                          ></i>
                      </label>
                      <select
                          className='form-select form-select-solid'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                          defaultValue={''}
                          value={formik.values.plano}
                          onChange={(e) => {
                            formik.setValues({...formik.values, plano: e.target.value})
                          }}
                        >
                          <option value={''} disabled>Selecione um plano</option>
                          {
                            currentUser 
                            && currentUser.companies 
                            && currentUser.companies.length > 0 
                            && currentUser.companies[0].planosCompany
                            && currentUser.companies[0].planosCompany.qtd_plants_plano > 0
                            && (
                              <option value={'PREMIUM'}>PREMIUM</option>
                            )
                          }
                          {
                            currentUser 
                            && currentUser.companies 
                            && currentUser.companies.length > 0 
                            && currentUser.companies[0].planosCompany
                            && currentUser.companies[0].planosCompany.qtd_plants_plano_starter > 0
                            && (
                              <option value={'STARTER'}>STARTER</option>
                            )
                          }

                          {
                            currentUser 
                            && currentUser.companies 
                            && currentUser.companies.length > 0 
                            && currentUser.companies[0].planosCompany
                            && currentUser.companies[0].planosCompany.qtd_plants_gratuita > 0
                            && (
                              <option value={'BASICA'}>BÁSICA</option>
                            )
                          }

                      </select>
                    </div>
                  </div>
              </div>

              <div>
                <div 
                  className={`symbol symbol-${width < 1200 ? '150px' : '150px'} symbol-fixed position-relative divSubImg`} 
                >
                  <img src={toAbsoluteUrl('/media/imgs/plantComposite.png')} alt='Metornic' />
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed flex-shrink-0 p-6 mb-5'>
          <KTSVG
            path='/media/icons/duotune/general/gen044.svg'
            className='svg-icon-2tx svg-icon-warning me-4'
          />
          <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
            <div className='mb-3 mb-md-0 fw-bold'>
              {/* <h4 className='text-gray-800 fw-bolder'>Database Backup Process Completed!</h4> */}
              <div className='fs-6 text-warning pe-7'>
                Para vincular usinas SIMPLES em COMPOSTAS, é necessario selecionar apenas 1 usina por marca (portal).  
              </div>
            </div>
          </div>
        </div>

        <ListPlantsForComposite
          className=''
          formik={formik}
          idUnitBranch={formik.values.idUnitBranch}
          show={show}
          includeAlreadyLinked={false}
        />

      </div>

      <div className='modal-footer py-lg-10 px-lg-10'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <button
                type='button'
                className='btn btn-lg btn-light'
                disabled={loading}
                onClick={() => {
                    closed()
                }}
            >
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
                <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
                
            </button>

            <button
                type='button'
                className='btn btn-lg btn-primary'
                disabled={loading || !formik.values.plantName || !formik.values.plano || !formik.values.idUnitBranch}
                onClick={submit}
            >
                Cadastrar
                {
                    loading ? 
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                    :
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                }
            </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalCreatePlantCompositeTable}
